import React, { useState } from "react";
import { MdOutlineEdit, MdDeleteOutline, MdAddCircleOutline } from "react-icons/md";
import { Table, Form, Button, Modal, Image } from "react-bootstrap";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import generique from "../../../assets/images/sousmenu/icon_generique_noir.png";
import onenote from "../../../assets/images/sousmenu/icon_onenote_noir.png";
import sharepoint from "../../../assets/images/sousmenu/icon_sharepoint_noir.png";
import powerbi from "../../../assets/images/sousmenu/icon_powerbi_noir.png";
import point from "../../../assets/images/sousmenu/icon_point_noir.png";
import silae from "../../../assets/images/sousmenu/icon_silae_noir.png";
import flipboard from "../../../assets/images/sousmenu/icon_flipboard_noir.png";
import pacte from "../../../assets/images/sousmenu/icon_pacte.png";
import teams from "../../../assets/images/sousmenu/icon_teams.png";
import colidee from "../../../assets/images/sousmenu/icon_colidee.png";
import media from "../../../assets/images/sousmenu/icon_media_noir.png";
import pdf from "../../../assets/images/sousmenu/icon_pdf_noir.png";
import mission from "../../../assets/images/sousmenu/icon_missions_noir.png";
import { useTranslation } from "react-i18next";

const ComponentSousmenusList = (props) => {
  const { t } = useTranslation();
  const { stateFromParent, handleSubmitData, handleSubmitDelete, parent, changeOrdre } = props;
  const initialSaisie = {
    nom: "",
    url: "",
    parent: parent,
    target: "_blank",
    icone: "aucun",
  };
  const [saisie, setSaisie] = useState(initialSaisie);

  const [showCreateUpdate, setShowCreateUpdate] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const [idSousmenu, setIdSousmenu] = useState("");

  const handleShowCreateUpdate = (id) => {
    if (id === "") {
      setSaisie(initialSaisie);
    } else {
      setIdSousmenu(id);
      setSaisie({
        nom: stateFromParent[id].nom,
        url: stateFromParent[id].url,
        parent: parent,
        icone: stateFromParent[id].icone,
      });
    }
    setShowCreateUpdate(true);
  };

  const handleCloseCreateUpdate = () => {
    setIdSousmenu("");
    setSaisie(initialSaisie);
    setShowCreateUpdate(false);
  };

  const handleShowDelete = (id) => {
    setIdSousmenu(id);
    setShowDelete(true);
  };
  const handleCloseDelete = () => {
    setIdSousmenu("");
    setShowDelete(false);
  };

  const submitSaisieToParent = () => {
    handleSubmitData(idSousmenu, saisie);
    handleCloseCreateUpdate();
  };

  const submitDeleteToParent = () => {
    handleSubmitDelete(idSousmenu);
    handleCloseDelete();
  };

  const switchIcon = () => {
    switch (saisie.icone) {
      case "generique":
        return generique;

      case "pointjaune":
        return point;

      case "silae":
        return silae;

      case "onenote":
        return onenote;

      case "sharepoint":
        return sharepoint;

      case "powerbi":
        return powerbi;

      case "flipboard":
        return flipboard;

      case "media":
        return media;

      case "pdf":
        return pdf;

      case "mission":
        return mission;

      case "pacte":
        return pacte;

      case "teams":
        return teams;

      case "colidee":
        return colidee;

      default:
        return "";
    }
  };

  return (
    <>
      <span role="button" onClick={() => handleShowCreateUpdate("")}>
        <MdAddCircleOutline size="1.5em" />
        {t("admin.PageAdminSousMenus.buttonAjouterSousMenu")}
      </span>
      <Table striped bordered hover className="stickyTable mt-2">
        <thead>
          <tr>
            <th>{t("admin.PageAdminSousMenus.titreColonne1")}</th>
            <th>{t("admin.PageAdminSousMenus.titreColonne2")}</th>
            <th>{t("admin.PageAdminSousMenus.titreColonne5")}</th>
            <th className="text-center">{t("admin.PageAdminSousMenus.titreColonne3")}</th>
            <th className="text-center">{t("admin.PageAdminSousMenus.titreColonne4")}</th>
          </tr>
        </thead>
        <tbody>
          {stateFromParent.map((sousmenu, index) => (
            <React.Fragment key={index}>
              {sousmenu.parent === parent && (
                <tr>
                  <td>
                    <TiArrowSortedUp
                      size="1.5em"
                      role="button"
                      onClick={(e) => changeOrdre(index, "haut", parent)}
                    />
                    <TiArrowSortedDown
                      size="1.5em"
                      role="button"
                      onClick={(e) => changeOrdre(index, "bas", parent)}
                    />
                    {sousmenu.nom}
                  </td>
                  <td>
                    <a href={sousmenu.url} target="_blank" rel="noreferrer">
                      {sousmenu.url.substr(0, 50)}
                      {sousmenu.url.length > 50 && <> ... </>}
                    </a>
                  </td>
                  <td>{sousmenu.icone}</td>
                  <td className="text-center">
                    <MdOutlineEdit
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowCreateUpdate(index)}
                    />
                  </td>
                  <td className="text-center">
                    <MdDeleteOutline
                      size="1.5em"
                      role="button"
                      onClick={() => handleShowDelete(index)}
                    />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </Table>
      {/* Mocale create update */}
      <Modal show={showCreateUpdate} onHide={handleCloseCreateUpdate}>
        <Modal.Header closeButton>
          <Modal.Title>
            {idSousmenu === ""
              ? t("admin.PageAdminSousMenus.modalCreateEditTitre1")
              : t("admin.PageAdminSousMenus.modalCreateEditTitre2")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <label className="mt-2">{t("commun.form.label.type_lien")}</label>
            <div className="d-flex">
              <Form.Select
                name="icone"
                value={saisie.icone}
                style={{ width: "25%" }}
                onChange={(e) => setSaisie({ ...saisie, [e.target.name]: e.target.value })}
              >
                <option value="">{t("commun.form.placeholder.aucun")}</option>
                <option value="pacte">Pacte</option>
                <option value="generique">
                  {t("admin.PageAdminSousMenus.modalIconSelectChoix1")}
                </option>
                <option value="pointjaune">
                  {t("admin.PageAdminSousMenus.modalIconSelectChoix2")}
                </option>
                <option value="media">{t("admin.PageAdminSousMenus.modalIconSelectChoix3")}</option>
                <option value="pdf">PDF</option>
                <option value="sharepoint">Sharepoint</option>
                <option value="powerbi">Power BI</option>
                <option value="onenote">One Note</option>
                <option value="flipboard">Flipboard</option>
                <option value="silae">Silae</option>
                <option value="mission">Mission</option>
                <option value="teams">Teams</option>
                <option value="colidee">Colidée</option>
              </Form.Select>
              <div className="d-flex align-items-center">
                <Image src={switchIcon()} className="ms-2" />
              </div>
            </div>

            <label className="mt-2">{t("commun.form.label.intitule1")}</label>
            <Form.Control
              type="text"
              name="nom"
              value={saisie.nom}
              onChange={(e) => setSaisie({ ...saisie, [e.target.name]: e.target.value })}
            />

            <label className="mt-2">{t("commun.form.label.url")}</label>
            <Form.Control
              type="text"
              name="url"
              value={saisie.url}
              onChange={(e) => setSaisie({ ...saisie, [e.target.name]: e.target.value })}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseCreateUpdate}>
            Annuler
          </Button>
          <Button variant="success" onClick={submitSaisieToParent}>
            {idSousmenu === "" ? "Ajouter" : "Modifier"}
          </Button>
        </Modal.Footer>
      </Modal>
      {/* modal delete */}
      <Modal show={showDelete} onHide={handleCloseDelete}>
        <Modal.Header closeButton>
          <Modal.Title>{t("admin.PageAdminSousMenus.modalDeleteTitre")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("admin.PageAdminSousMenus.modalDeleteText")}</Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseDelete}>
            {t("commun.form.button.annuler")}
          </Button>
          <Button variant="success" onClick={submitDeleteToParent}>
            {t("commun.form.button.confirmSuppression")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ComponentSousmenusList;
